/** * 弹窗演示 * 徐杰 * 2019-4-22 **/
<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-qiye" /> 企业设备管理 </BreadcrumbItem>
        </Breadcrumb>
        <i-button class="refresh" size="small" type="success">
          <Icon title="刷新" class="icon" type="ios-refresh" @click="reload" />
        </i-button>
      </div>
      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <!-- 搜索栏 -->

        <!-- 数据表格 -->
        <i-table width="100%" border :columns="columns2" :data="companylist" />
        <!-- 分页 -->
        <Page
          style="margin-top: 0.625rem"
          show-total
          :total="total"
          show-sizer
          @on-change="onNextPage"
          @on-page-size-change="onPageSize"
        />
      </Card>
    </X-Layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      comid: '',
      company_name: '',
      modal1: false,
      listindex: '', // 删除数组中的第几个数据
      value: '',
      columns2: [
        {
          type: 'index',
          title: '序号',
          minWidth: 30,
          align: 'center',
        },
        {
          title: '设备编号',
          key: 'gkEquip_mn',
          align: 'center',
          minWidth: 120,
          sortable: true,
        },
        {
          title: '图片',
          key: 'action',
          align: 'center',
          minWidth: 120,
          sortable: true,
          render: (h, column, params) => {
            let picList = [];
            if (column.row.picUrl) {
              var picUrlList = column.row.picUrl.split(',');

              for (var i = 0; i < picUrlList.length; i++) {
                if (picUrlList[i]) {
                  picList.push(
                    h('img', {
                      attrs: {
                        src: picUrlList[i],
                      },
                      style: {
                        marginRight: '5px',
                        marginTop: '5px',
                        marginBottom: '5px',
                        height: '50px',
                        width: '50px',
                      },
                    }),
                  );
                }
              }
            }

            return h('div', picList);
          },
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          minWidth: 180,
          align: 'center',
          render: (h, column, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.show2(column.row.gkEquip_id, column.row.picUrl, column.row.company_id);
                    },
                  },
                },
                '修改信息',
              ),
            ]);
          },
        },
      ],

      companylist: [], // 公司列表
      page: 1, // 页数
      row: 10, // 条数
      total: 0, // 总条数
    };
  },

  mounted() {
    this.comid = this.$route.query.comid;

    this.getCompanyInfo(this.page);
  },
  methods: {
    /**
     * 获取公司信息
     */
    getCompanyInfo(page, row) {
      this.select = 1;
      const that = this;
      const api = this.ApiUrl + 'gkEquip/findByCompanyId';
      const data = {
        page: that.page,
        row: that.row,
        company_id: that.comid,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            const list = res.data.extend.pageInfo.records;
            that.total = res.data.extend.pageInfo.total;
            that.page = res.data.extend.page;
            let uploadList = [];
            if (!list.picUrl) {
              uploadList = [];
            } else {
              if (list.picUrl.match(',')) {
                uploadList = list.picUrl.split(',');
              } else {
                uploadList.push(list.picUrl);
              }
            }
            if (!list.picUrlList) {
              list.picUrlList = uploadList;
            }
            that.companylist = list;
          }
        },
        res => {},
      );
    },

    ok() {
      const that = this;
      const api = this.ApiUrl + 'company/delById';
      const data = {
        company_id: this.listindex,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            this.getCompanyInfo(1, 10);
          }
        },
        res => {},
      );
    },
    cancel() {
      this.$Message.info('Clicked cancel');
    },

    // 表格删除事件
    deldata(index) {
      this.modal1 = true;
      this.listindex = index;
    },
    // 表格事件处理
    show2(index, url, comid) {
      this.$router.push({
        name: 'upshebei',
        query: {
          comid: index,
          url: url,
          comids: comid,
        },
      });
    },
    show3(e) {
      console.log(e);
    },
    show4(index, id) {
      sessionStorage.setItem('admid', index);
      if (id == '0') {
        sessionStorage.setItem('yytype', 0);
      } else {
        sessionStorage.setItem('yytype', 1);
      }

      this.$router.push({
        name: 'newcompany',
        params: {
          comid: index,
        },
      });
    },
    // 添加公司
    addcompany() {
      this.$router.push({
        name: 'addcompany',
      });
    },
    // 切换显示的页数
    onPageSize(e) {
      this.row = e;
      if (this.select == 1) {
        this.getCompanyInfo(this.page, this.row);
      } else if (this.select == 2) {
        this.getCompanynameInfo()(this.page, this.row);
      }
    },
    // 切换下一页
    onNextPage(e) {
      this.page = e;
      if (this.select == 1) {
        this.getCompanyInfo(this.page, this.row);
      } else if (this.select == 2) {
        this.getCompanynameInfo()(this.page, this.row);
      }
    },
    // 刷新页面
    reload() {
      location.reload();
    },
    /**
     * 点击确定事件1
     */
    clickOK1() {
      this.$Message.info('点击确认');
    },
    /**
     * 点击取消事件
     */
    clickCancel1() {
      this.$Message.info('点击取消');
    },
    /**
     * 删除事件
     */
    clickDel() {
      this.modal_loading = true; // 开启加载动画

      setTimeout(() => {
        this.modal_loading = false;
        this.modal2 = false;
        this.$Message.success('窗口隐藏');
      }, 2000);
    },
    /**
     * 加载html内容到弹窗
     */
    clickHTML() {
      this.modal3 = true;
      this.chtml =
        '<p>这个 <code>span</code> 的内容将会被替换成为属性值 <code>rawHtml</code>，直接作为 HTML——会忽略解析属性值中的数据绑定。注意，你不能使用 <code>v-html</code> 来复合局部模板，因为 Vue 不是基于字符串的模板引擎。反之，对于用户界面 (UI)，组件更适合作为可重用和可组合的基本单位。</p><p class="tip">你的站点上动态渲染的任意 HTML 可能会非常危险，因为它很容易导致 <a href="https://en.wikipedia.org/wiki/Cross-site_scripting" target="_blank" rel="noopener">XSS 攻击</a>。请只对可信内容使用 HTML 插值，<strong>绝不要</strong>对用户提供的内容使用插值。</p><p>在布尔特性的情况下，它们的存在即暗示为 <code>true</code>，<code>v-bind</code> 工作起来略有不同，在这个例子中：</p><pre><code class="hljs html"><span class="hljs-tag">&lt;<span class="hljs-name">button</span> <span class="hljs-attr">v-bind:disabled</span>=<span class="hljs-string">"isButtonDisabled"</span>&gt;</span>Button<span class="hljs-tag">&lt;/<span class="hljs-name">button</span>&gt;</span></code></pre>';
    },
    /**
     * iview封装了一些实例方法，用来创建一次性的轻量级对话框。
     */
    dongtai() {
      const title = '标题';
      const content = '<p>内容。。。</p><p>Xujie。。。</p>';

      this.$Modal.success({
        title: title,
        content: content,
      });
    },
    /**
     * 跳转到添加企业
     */
    toAddCompany() {
      this.$router.push({
        name: 'newcompany',
        params: {
          admid: 123,
        },
      });
    },
  },
};
</script>

<style scoped>
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
}

.tabdiv {
  margin-left: 1.25rem;
}
</style>
